<app-leveltwo [pageName]="'Registered Domestic Partners Exclusion'">
    <div heading="General Info" class="General">
      <h3>{{'RegisteredDomestic.PageTitle'|translate}}</h3>

      <h4>{{'RegisteredDomestic.Rightsand'|translate}}</h4>

      <p>{{'RegisteredDomestic.Effective'|translate}}</p>
      <ul>
        <li>{{'RegisteredDomestic.Transfers1'|translate}}</li>
        <li>{{'RegisteredDomestic.Transfers2'|translate}}</li>
        <li>{{'RegisteredDomestic.Transfers3'|translate}}</li>
        <li>{{'RegisteredDomestic.Transfers4'|translate}}</li>
        <li>{{'RegisteredDomestic.Transfers5'|translate}}</li>
      </ul>

      <p>{{'RegisteredDomestic.Thelist'|translate}}</p>
<!--
      <h5>{{'RegisteredDomestic.Whomay'|translate}}</h5>
      <p>{{'RegisteredDomestic.FamilyCode'|translate}}</p>
      <ul>
        <li>{{'RegisteredDomestic.Code1'|translate}}</li>
        <li>{{'RegisteredDomestic.Code2'|translate}}</li>
        <li>{{'RegisteredDomestic.Code3'|translate}}</li>
        <li>{{'RegisteredDomestic.Code4'|translate}}</li>
        <li>{{'RegisteredDomestic.Code5'|translate}}</li>
        <li>{{'RegisteredDomestic.Code6'|translate}}</li>
      </ul>

      <p>{{'RegisteredDomestic.Therterm'|translate}}</p>

      <h5>{{'RegisteredDomestic.Doesthe'|translate}}</h5>

      <p>{{'RegisteredDomestic.Formarriages'|translate}}</p>

      <h5>{{'RegisteredDomestic.Whatisthe'|translate}}</h5>

      <p>{{'RegisteredDomestic.Noseparate'|translate}}</p>

      <h5>{{'RegisteredDomestic.HowmayIenter'|translate}}</h5>

      <p>{{'RegisteredDomestic.Provisions'|translate}} <a href="https://www.sos.ca.gov/registries/domestic-partners-registry" target="_blank">{{'RegisteredDomestic.sos.ca.gov'|translate}}</a></p>

      <p>{{'RegisteredDomestic.Provisions2'|translate}}</p>

      <p>{{'RegisteredDomestic.Provisions3'|translate}} <a href="https://www.sos.ca.gov/registries/domestic-partners-registry" target="_blank">{{'RegisteredDomestic.sos.ca.gov'|translate}}</a></p>

      <h5>{{'RegisteredDomestic.Howmayareg'|translate}}</h5>

      <p>{{'RegisteredDomestic.Thedomestic'|translate}}</p>
      <p>{{'RegisteredDomestic.Thecalifornia'|translate}}</p>

      <h5>{{'RegisteredDomestic.WhataretheTermination'|translate}}</h5>

      <p>{{'RegisteredDomestic.Similarto'|translate}}</p>
      <p>{{'RegisteredDomestic.Thisincludes'|translate}}</p>

      <h5>{{'RegisteredDomestic.WhataretheDeath'|translate}}</h5>

      <p>{{'RegisteredDomestic.ForSpouses'|translate}}</p>
      <p>{{'RegisteredDomestic.Forregistered'|translate}}</p>

      <h5>{{'RegisteredDomestic.Doesthedomestic'|translate}}</h5>

      <p>{{'RegisteredDomestic.UnderFamilycode'|translate}}</p>

      <h5>{{'RegisteredDomestic.LegalDisclaimer'|translate}}</h5>
      <p>{{'RegisteredDomestic.Theright'|translate}}</p>
      <p>{{'RegisteredDomestic.Transferring'|translate}}</p>
      <p>{{'RegisteredDomestic.Theinformation'|translate}}</p>
-->
    </div>
    <!-- <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab> -->
</app-leveltwo>
